/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface ISignUpLink {
    id: string;
    href: string;
    className: string;
    text: string;
}

const SignUpLink: React.FC<ISignUpLink> = ({ id, href, className, text }) => (
    <a id={`${id}_link`} className={`${className}-link`} href={href}>
        {text}
    </a>
);

export default SignUpLink;
